import * as React from 'react';
import onClickOutside from 'react-onclickoutside';
import classnames from 'classnames';

import './style.scss';

export const enum ToolType {
  FEES = 'fees',
  PRINT_QUEUE = 'print',
  CONTACTS = 'contacts',
  COMMLINK = 'commlink',
  AGENCY_SETUP = 'setup',
  HELP = 'help',
  FINANCE = 'finance',
}

interface ITool {
  toolType: ToolType;
  onClick: (e: React.SyntheticEvent<HTMLElement>) => void;
  URL?: string;
  label?: string;
  iconUrl?: string;
}

interface IToolsDropdownProps {
  show: boolean;
  onClose: (e: React.SyntheticEvent<any>) => void;
  pathName: string;
  tools: ITool[];
}

interface IToolsDropdownState {}

export class ToolsDropdown extends React.Component<IToolsDropdownProps, IToolsDropdownState> {
  isActiveTool = (url: string) => this.props.pathName.includes(url);

  handleClickOutside = (e: any) => {
    const menuIconClassName = 'app-header__menu__icon';
    const targetClassNames = Array.from(e.target.classList);
    const isTargetMenuIcon = targetClassNames.indexOf(menuIconClassName) !== -1;

    if (!isTargetMenuIcon) {
      this.props.onClose(e);
    }
  };

  renderTool = (tool: ITool, index): JSX.Element => {
    const toolTypeName = {
      [ToolType.FEES]: 'Fees & Payments',
      [ToolType.PRINT_QUEUE]: 'Print Queue',
      [ToolType.CONTACTS]: 'Contacts',
      [ToolType.COMMLINK]: 'CommLink',
      [ToolType.AGENCY_SETUP]: 'Agency Setup',
      [ToolType.HELP]: 'Help',
      [ToolType.FINANCE]: 'Finance',
    };

    const onToolClick = (e: React.SyntheticEvent<HTMLElement>) => {
      if (tool.onClick) {
        tool.onClick(e);
        this.props.onClose(e);
      }
    };

    return (
      <div
        key={index}
        className={classnames('tools-dropdown__tool', 'flex-column--center', {
          active: this.isActiveTool(tool.URL),
        })}
        onClick={onToolClick}
      >
        {tool.iconUrl ? (
          <img src={tool.iconUrl} />
        ) : (
          <a
            className={classnames('tools-dropdown__tool-img', `tools-dropdown__tool-img--${tool.toolType}`, {
              active: this.isActiveTool(tool.URL),
            })}
            href={tool.URL}
          />
        )}
        <label className={classnames('tools-dropdown__tool-name')}>
          {tool.label ? tool.label : toolTypeName[tool.toolType]}
        </label>
      </div>
    );
  };

  render() {
    return (
      <div
        className={classnames('tools-dropdown', 'grid-3-cols-2-rows', 'grid-padding', {
          'tools-dropdown--visible': this.props.show,
          'grid-2-col': this.props.tools.length === 2,
        })}
      >
        {this.props.tools.map((tool, index) => this.renderTool(tool, index))}
      </div>
    );
  }
}

export default onClickOutside(ToolsDropdown);
